import type { SavingsReport } from "@pentacode/core";
import { parseDateString, toDateString } from "@pentacode/core";

export function savingsDays(dailyReports: SavingsReport[], today = toDateString(new Date())) {
    return dailyReports.map((report) => ({
        date: parseDateString(report.from)!,
        savings: report.from < today ? report.savings : undefined,
    }));
}

export function previewSavings(year: number, month: number) {
    const dayCount = new Date(year, month + 1, 0).getDate();
    const days = Array.from({ length: dayCount }, (_, i) => ({
        date: new Date(year, month, i + 1),
        savings: Math.round(22 + 6 * Math.sin(i * 1.3) + 4 * Math.sin(i * 0.45)),
    }));
    return { days, fees: 174 };
}

export function tileSavings(dailyReports: SavingsReport[], year: number, month: number) {
    const savings = dailyReports.reduce((total, report) => total + report.savings, 0);
    if (!savings) {
        return previewSavings(year, month);
    }
    const fees = dailyReports.reduce((total, report) => total + report.fees, 0);
    return { days: savingsDays(dailyReports), fees };
}
